import { useGlobalState, useSelectors } from '@exodus/headless-react';
import { useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import useConfig from './use-config.js';
import useFromAsset from './use-from-asset.js';
import { useExchangeFormContext } from '../context/exchange-form.js';
const useToAsset = () => {
    const config = useConfig();
    const selectors = useSelectors();
    const [fromAsset] = useFromAsset();
    const exchangeFormContext = useExchangeFormContext();
    if (!exchangeFormContext) {
        throw new Error('useFromAsset must be used inside ExchangeFormContextProvider');
    }
    const [toAssetName, setToAssetName] = useGlobalState({
        namespace: 'exchange',
        key: 'toAssetName',
        defaultValue: config.defaultToAsset,
        persist: true,
    });
    const setToAsset = useCallback((value) => setToAssetName(typeof value === 'string' ? value : value.name), [setToAssetName]);
    const resetToAsset = () => setToAsset(config.defaultToAsset);
    const availableAssets = useSelector(selectors.availableAssets.all);
    const currentAsset = availableAssets[toAssetName];
    const defaultAsset = availableAssets[fromAsset.name === config.defaultToAsset ? config.defaultFromAsset : config.defaultToAsset];
    const fallbackAsset = Object.values(availableAssets)[1];
    const asset = useMemo(() => (currentAsset || defaultAsset || fallbackAsset), [currentAsset, defaultAsset, fallbackAsset]);
    return [asset, setToAsset, resetToAsset];
};
export default useToAsset;
